module.exports = __webpack_public_path__ + "static/media/tflogistics.640fa406.png";